import { atom } from "recoil"

export const accountRequestIdState = atom({
  key: "atoms/user/accountRequestIdState",
  default: 0,
})
